import _ from 'lodash'
import { Record } from 'immutable'

export const ModalData = Record({
  title: "",
  description: "",
  confirm: "Yes, Continue",
  buttonProps: {},
  onConfirm: _.noop,
  onCancel: _.noop,
})



// WEBPACK FOOTER //
// ./src/scripts/utils/ModalHelpers.js